import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, Output, Input } from '@angular/core';
import { Subject } from '@microsoft/signalr';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { DialogTypeEnum } from 'src/app/dashboard/interfaces/DialogType';
import { DupDialogTypeEnum } from 'src/app/dashboard/interfaces/DupDialogTypeEnum';
import { groupByProperty, sortByProperty } from 'src/app/shared/helpers/helpers';
import { ActivityTypesEnum } from 'src/app/shared/interfaces/ActivityTypesEnum';
import { AlertTypesEnum } from 'src/app/shared/interfaces/AlertTypesEnum';
import { IDupTransaction } from 'src/app/shared/interfaces/IDupTransaction';
import { FormattedDatePipe } from 'src/app/shared/pipes/formatted-date/formatted-date.pipe';
import { PharmacyState } from 'src/app/shared/states/pharmacy/pharmacy.state';
import { TransactionsState } from 'src/app/shared/states/transactions/transactions.state';
@UntilDestroy()
@Component({
  selector: 'app-dup-transactions-dialog',
  templateUrl: './dup-transactions-dialog.component.html',
  styleUrls: ['./dup-transactions-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DupTransactionsDialogComponent implements OnInit {
  
  @Input() dialogType: DupDialogTypeEnum = DupDialogTypeEnum.Dispense;
  @Input() drugIds: number[] = [];
  
  @Output() save: EventEmitter<any> = new EventEmitter();
  @Output() cancel: EventEmitter<void> = new EventEmitter();
  
  AlertTypesEnum = AlertTypesEnum;
  DupDialogTypeEnum = DupDialogTypeEnum;
  
  header = 'Potential Duplicate Dispense';

  saveAllButtonMinWidth = 160;

  locationsEnabled: boolean;
  
  @Select(TransactionsState.duplicateTransactions) duplicateTransactions$: Observable<IDupTransaction[]>;
  @Select(PharmacyState.inventoryLocationsEnabled) inventoryLocationsEnabled$: Observable<boolean>;

  filteredDuplicates$: BehaviorSubject<IDupTransaction[]> = new BehaviorSubject<IDupTransaction[]>([]);

  constructor(private formattedDatePipe: FormattedDatePipe) { }

  ngOnInit(): void {
    if (this.dialogType === DupDialogTypeEnum.RegularAmendment || this.dialogType === DupDialogTypeEnum.SplitNdcsAmendment) {
      this.header = 'Potential Duplicate Amendment';
    }

    this.duplicateTransactions$
    .pipe(untilDestroyed(this))
    .subscribe(dupes => {
      if (!this.drugIds?.length) {
        this.filteredDuplicates$.next(dupes);
      } else {
        this.filteredDuplicates$.next(dupes?.filter(x => this.drugIds.includes(x.drugId)));
      }
    });

    this.inventoryLocationsEnabled$.pipe(take(1)).subscribe(val => this.locationsEnabled = val);
  }


  getAlertMessage(dupes: IDupTransaction[]): string {
    const mostRecentDupe = sortByProperty([...dupes], 'createDate', false)[0] as IDupTransaction;
    return `${mostRecentDupe?.firstName} ${mostRecentDupe?.lastName} recorded a similar transaction on ${this.formattedDatePipe.transform(mostRecentDupe?.createDate, 'MMM d a, HH:mm yyyy')}`;

  }

}
